import { ComponentsConfig } from './components.abstract.config';

export const componentsConfig: ComponentsConfig = {
  privileges: {
    assigned: {
      // TODO(MOJAT-3794): rename to shortlist after deploying epic
      candidates: 'web:assigned-candidates',
      jobs: 'web:assigned-jobs',
    },
    associate: {
      candidate_to_job: 'web:associate-candidate-to-job',
      jobs_to_candidate: 'web:associate-jobs-to-candidate',
    },
    job: {
      view: 'web:jobs-view',
      create: 'web:jobs-create',
      edit: 'web:jobs-edit',
      notes: 'web:jobs-notes',
      files: 'web:jobs-files',
      publish: 'web:jobs-publish',
    },
    candidates: {
      edit: 'web:candiadtes-edit',
      notes: 'web:candiadtes-notes',
      resumes: 'web:candiadtes-resumes',
      files: 'web:candiadtes-files',
      filesReadOnly: 'web:candidates-files:read-only',
    },
  },
};
